export const getLogoFilename = (provider) => {
    if (!provider) return '../ecommerce/product-image-placeholder.png'
    if (provider === 'maas') return 'acm.png'
    return `${provider}.png`
}

export const getProviderLogoPath = (provider) => {
    const filename = getLogoFilename(provider)
    if (!provider || filename.includes('product-image-placeholder')) {
        return './assets/images/providers/local.png'
    }
    return `./assets/images/providers/${filename}`
}

/**
 * Providers whose clusters can be powered off and back on. Mirrors the API's
 * nodus-core/src/libs/autoTeardown.js and the gate on the Stop menu item in
 * ClusterActionMenu.js. Oracle deploys and destroys but cannot stop.
 */
export const STOP_CAPABLE_PROVIDERS = ['aws', 'gcp', 'azure', 'ibm']

export const providerSupportsStop = (provider) => STOP_CAPABLE_PROVIDERS.includes(provider)

/**
 * Providers the auto teardown timer is not offered for. ACM/MaaS clusters are
 * on-prem bare metal out of a pool - no meter is running, so a clock that
 * destroys one buys nothing.
 */
export const TIMER_UNSUPPORTED_PROVIDERS = ['maas']

export const providerSupportsTimer = (provider) => !TIMER_UNSUPPORTED_PROVIDERS.includes(provider)
